var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"switch-input",attrs:{"align":"center"}},[_c('v-switch',{attrs:{"hide-details":"","inset":"","color":_vm.color},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('span',{staticClass:"pt-4",class:{
            'enable-switch' : _vm.value,
            'desabled-switch' : !_vm.value,
        }},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }